import PostMessageProcessor from '../common/js/lib/PostMessageProcessor';

export default PostMessageProcessor;


// WEBPACK FOOTER //
// ./postmessage/processor.js